import { Idea } from 'models/ideaModels'

const getSubmittedIdeasPrompt = (questionText: string, ideasDataset: Idea[]) =>
	`For the following dataset, ${questionText}: ${JSON.stringify(
		ideasDataset
	)}`

export { getSubmittedIdeasPrompt }
